import React from "react";
import "./Quiz.css";
import Slide from "./components/Slide";
import { imagePath, nextIndex } from "./utils";
import ButtonBar from "./components/ButtonBar";
import ScoreCard from "./components/Score";

let cardset = [];

class Quiz extends React.Component {
  state = {
    current: 0,
    scores: [0, 0],
    qclasses: "question",
    aclasses: "answer",
    sclasses: "score-card",
    questionCount: 0,
    team: "A",
    disabled: []
  };

  constructor() {
    super();
    const savedCardSet = localStorage.getItem("cardset");
    if (savedCardSet) {
      cardset = JSON.parse(savedCardSet);
    }

    if (!cardset.length) {
      cardset = [...Array(50 * 4).keys()]
        .sort(() => (Math.random() < 0.5 ? -1 : 1))
        .map(i => ({ card: Math.floor(i / 4 + 1), band: i % 4 }));
      localStorage.setItem("cardset", JSON.stringify(cardset));
    }
  }

  componentDidMount() {
    this.reset();
    this.incrementQuestion();
    setTimeout(() => this.showQuestionCard(), 1000);
  }

  startnewGame() {
    this.setState({ questionCount: 1, team: "A", scores: [0, 0] });
    this.showScoreCard();
    setTimeout(() => {
      this.setState({ current: nextIndex(this.state.current, cardset.length) });
      this.showQuestionCard();
    }, 1000);
  }
  incrementQuestion() {
    this.setState({ questionCount: this.state.questionCount + 1 });
  }
  nextTeam() {
    this.setState({ team: this.state.team === "A" ? "B" : "A" });
  }

  reset() {
    this.setState({ aclasses: "answer" });
    this.setState({ qclasses: "question" });
    this.setState({ sclasses: "score-card" });
    this.setState({ tclasses: "" });
  }

  gotoNextQuestion() {
    this.reset();
    this.nextTeam();
    if (this.state.team === "B") this.incrementQuestion();
    this.showScoreCard();
    setTimeout(() => {
      this.setState({ current: nextIndex(this.state.current, cardset.length) });
      this.showQuestionCard();
    }, 1000);
  }

  showAnswerCard() {
    this.setState({ aclasses: "answer showing" });
    this.setState({ qclasses: "question hiding" });
    this.setState({ sclasses: "score-card" });
    this.setState({ disabled: [] });
  }

  showQuestionCard() {
    this.setState({ aclasses: "answer hiding" });
    this.setState({ sclasses: "score-card" });
    this.setState({ qclasses: "question showing" });
    this.showTeam();
    this.setState({ disabled: ["correct_10", "correct_5", "next"] });
  }

  showScoreCard() {
    this.reset();
    this.setState({ sclasses: "score-card showing" });
  }

  showTeam() {
    this.setState({ tclasses: "team showing" });
  }

  onAnswer() {
    return () => this.showScoreCard();
  }

  onScoreCard() {
    return () => this.gotoNextQuestion();
  }

  onQuestion() {
    return () => this.showAnswerCard();
  }

  setScore(n) {
    const i = this.state.team === "A" ? 0 : 1;
    const { scores } = this.state;
    scores[i] += n;
    this.setState({ scores });
    this.showScoreCard();
  }

  onButton() {
    return name => {
      switch (name) {
        case "new":
          this.startnewGame();
          break;
        case "question":
          this.showQuestionCard();
          break;
        case "answer":
          this.showAnswerCard();
          break;
        case "correct_10":
          this.setScore(10);
          break;
        case "correct_5":
          this.setScore(5);
          break;
        case "scoreboard":
          this.showScoreCard();
          break;
        case "clear":
          this.reset();
          break;
        case "next":
          this.gotoNextQuestion();
          break;
        default:
          break;
      }
    };
  }

  cacheNextCard() {
    const imgsrc = imagePath(
      "questions",
      cardset[nextIndex(this.state.current, cardset.length)].card
    );
    setTimeout(() => {
      new Image().src = imgsrc;
    }, 500);
  }

  render() {
    const { card, band } = cardset[this.state.current];
    this.cacheNextCard();

    return (
      <div>
        <div className="Quiz">
          <ScoreCard
            scores={this.state.scores}
            team={this.state.team}
            question={this.state.questionCount}
            handler={this.onScoreCard()}
            classes={this.state.sclasses}
          />
          <Slide
            path={imagePath("questions", card)}
            band={band}
            handler={this.onQuestion()}
            classes={this.state.qclasses}
          />
          <Slide
            path={imagePath("answers", card)}
            band={band}
            handler={this.onAnswer()}
            classes={this.state.aclasses}
          />
        </div>
        <div className={`team ${this.state.tclasses}`}>{this.state.team}</div>
        <ButtonBar handler={this.onButton()} disabled={this.state.disabled} />
      </div>
    );
  }
}

export default Quiz;
